// src/features/auth/pages/LoginPage.jsx
import React, { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { faEyeSlash, faEye } from "@fortawesome/free-solid-svg-icons";
import AuthInputField from "../../components/ui/input/AuthInputs";
import AuthPassInputField from "../../components/ui/input/AuthInputs/AuthInputPassword";
import AuthLayout from "../../layouts/LoginLayout";
import loginimages from "../../Images/Login/LoginImages";
// import AuthStyle from '../../style/components/auth/LoginForm.module.css';
import PagesStyle from "../../style/Pages/Auth/LoginPage.module.css";
import Loader from "../../components/ui/Loader/Loader";
import { useSignin } from "../../hooks/useAuth";
import ForgotPassword from "./ForgotPassword";
import { isAuthenticated } from "../../utils/authenticated";
import DeactiveLogin from "../../components/ui/Warning/DeactiveLogin";
import images from "../../utils/images";

const SigninPages = () => {
  // const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [showForgot, setShowForgot] = useState(false);
  const [deactivatedMessage, setDeactivatedMessage] = useState(""); // 🔹 for popup

  const {
    loading,
    error,
    emailError,
    passwordError,
    handleInputChange,
    handleSubmit,
  } = useSignin(setDeactivatedMessage);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  if (isAuthenticated()) {
    return <Navigate to="/homepage" />;
  }
  return (
    <>
      <AuthLayout
        image={loginimages.Login_images}
        subtitle="Welcome back! Log in to access your account."
        footerLinks={[
          {
            text: "Don't have an account?",
            link: "/register",
            linkText: "Sign up",
          },
        ]}
        logo={images.logoimg}
      >
        <div className={PagesStyle.loginFromContainer}>
          <form onSubmit={handleSubmit}>
            <AuthInputField
              label="Email"
              type="text"
              name="email"
              onChange={(e) => handleInputChange("email", e.target.value)}
              placeholder="Enter Email"
              error={emailError}
              required
            />

            <AuthPassInputField
              label="Password"
              name="password"
              type={showPassword ? "text" : "password"}
              onChange={(e) => handleInputChange("password", e.target.value)}
              placeholder="Enter Password"
              error={passwordError}
              icon={showPassword ? faEye : faEyeSlash}
              onIconClick={togglePasswordVisibility}
              required
            />

            <div className={PagesStyle.loginForgotPassCont}>
              <Link
                className={PagesStyle.loginForgotPass}
                onClick={() => setShowForgot(true)}
              >
                Forgot Password?
              </Link>
            </div>

            <button
              type="submit"
              className={PagesStyle.loginButton}
              disabled={loading}
            >
              {loading ? <Loader /> : "Log in"}
            </button>

            {error && <div className="error-message">{error}</div>}
          </form>

          <div className={PagesStyle.dividerLogin}>
            <span>###</span>
          </div>
        </div>
      </AuthLayout>
      {showForgot && (
        <ForgotPassword
          OnClose={() => {
            setShowForgot(false);
          }}
        />
      )}
      {deactivatedMessage && (
        <DeactiveLogin onClose={() => setDeactivatedMessage("")} />
      )}
    </>
  );
};

export default SigninPages;
